import React, { useEffect } from 'react';

import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

import useForm from '../../../hooks/useForm';

import PageTitle from '../../PageTitle';
import FormWrapper from '../../FormWrapper';
import SaveButton from '../../buttons/SaveButton';
import CancelButton from '../../buttons/CancelButton';
import usePermissions from '../../../hooks/usePermission';

const permissionsMap = {
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const EditTransportTypeForm = ({ type, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { canEdit } = usePermissions(permissionsMap);
  const { handleSubmit, value, input, setFormValue } = useForm({
    initialValue: type,
    onSubmit,
    onCancel,
  });

  useEffect(() => {
    setFormValue(type);
  }, [setFormValue, type]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PageTitle
          title={type.name || t('entity.taxonomy.transportType._singular')}
        />
        <FormWrapper>
          <FormWrapper.Single>
            <FormWrapper.Input
              label={t('entity.taxonomy.transportType.name')}
              props={{
                ...input('name'),
                disabled: value.deleted || !canEdit,
              }}
            />
          </FormWrapper.Single>
        </FormWrapper>

        <Space style={{ paddingTop: '1rem' }}>
          {canEdit && <SaveButton disabled={value.deleted} />}
          <CancelButton onCancel={onCancel} />
        </Space>
      </form>
    </>
  );
};
export default EditTransportTypeForm;
